__turbopack_context__.v({
  "main-nav": "MQmJSq_main-nav",
  "main-nav-item": "MQmJSq_main-nav-item",
  "main-nav-item-icon": "MQmJSq_main-nav-item-icon",
  "main-nav-item-title": "MQmJSq_main-nav-item-title",
  "main-nav-unnested-chevron": "MQmJSq_main-nav-unnested-chevron",
  "menu-title": "MQmJSq_menu-title",
  "menu-title-container": "MQmJSq_menu-title-container",
  "no-link-item": "MQmJSq_no-link-item",
  "sub-nav": "MQmJSq_sub-nav",
  "sub-nav-link": "MQmJSq_sub-nav-link",
  "sub-nav-link-description": "MQmJSq_sub-nav-link-description",
  "sub-nav-menu": "MQmJSq_sub-nav-menu",
  "sub-nav-menu-without-subtitle": "MQmJSq_sub-nav-menu-without-subtitle",
});
